export interface LogContext {
  tags?: Record<string, boolean | number | string>
}

export interface BookingErrorReporter {
  captureException: (exception: unknown) => void
  captureMessage: (message: string, context?: LogContext) => void
}

let reporter: BookingErrorReporter | undefined

// Module state, not $provide: logError also runs in $fetch hooks, outside the server Nuxt context.
export function setBookingErrorReporter(nextReporter: BookingErrorReporter) {
  reporter = nextReporter
}

export function safeStringify(value: unknown) {
  const seen = new WeakSet<object>()

  return JSON.stringify(value, (_key, item: unknown) => {
    if (item instanceof Error) {
      return {
        name: item.name,
        message: item.message,
        stack: item.stack,
        cause: item.cause,
      }
    }

    if (item && typeof item === 'object') {
      if (seen.has(item)) {
        return '[Circular]'
      }

      seen.add(item)
    }

    return item
  })
}

export function logError(exception: unknown) {
  console.error(exception instanceof Error ? exception.message : safeStringify(exception))
  reporter?.captureException(exception)
}

export function logMessage(message: string, context?: LogContext) {
  reporter?.captureMessage(message, context)
}
